import http from "../http";

export const fetchMyStores = () => http.get("/store-management/my-stores/");

export const fetchStoreBasicInfo = (id) =>
  http.get(`/store-management/store/${id}/`);

export const updateStoreBasicInfo = (id, data) =>
  http.put(`/store-management/store/${id}/`, data);

export const checkSlug = (slug, storeId = null) => {
  let url = `/store-management/check-slug/?slug=${slug}`;

  if (storeId) {
    url += `&store_id=${storeId}`;
  }

  return http.get(url);
};
